import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Button, message} from "antd"
import MultiInput from "./MultiInput"
import SingleInput from "./SingleInput"
import RadioInput from "./RadioInput"
import SelectInput from "./SelectInput"
import RadioMultiInput from "./RadioMultiInput"
import getHistory from "../../../../getHistory"
import SelectMulti from "./SelectMulti"
import ModalConfirm from "../../../SettingShippingRuleNew/components/templates/ModalConfirm"
import AddTagInput from "./AddTagInput";
import MultiInputSKU from './MultiInputSKU'
import { getSkuVariants } from '../../../../services/api/apiPacking'

FormShippingRule.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    platforms: PropTypes.array,
    onUpdateShippingRule: PropTypes.func.isRequired,
    shippingRules: PropTypes.object
}

function FormShippingRule(props) {
    const [priority, setPriority] = useState('')
    const [platform, setPlatform] = useState({allow: []})
    const [country, setCountry] = useState({allow: [], disallow: []})
    const [state, setState] = useState({allow: [], disallow: []})
    const [store, setStore] = useState({allow: [], disallow: []})
    const [type, setType] = useState({allow: [], disallow: []})
    const [tag, setTag] = useState({allow: [], disallow: []})
    const [weight, setWeight] = useState()
    const [shipping_carrier, setShippingCarrier] = useState('')
    const [original_carrier, setOriginalCarrier] = useState('')
    const [active, setActive] = useState(true)
    const [validate, setValidate] = useState({})
    const [isOpen, setIsOpen] = useState(false)
    const [tags, setTags] = useState([])
    const [shipping_level, setShippingLevel] = useState('')
    const [fieldAdding, setFieldAdding] = useState({allow: [], disallow: []})
    const [detectByVariants, setDetectByVariants] = useState(false)
    const [acceptSkuVariants, setAcceptSkuVariants] = useState([])
    const [exceptSkuVariants, setExceptSkuVariants] = useState([])
    const [acceptSkuVariantsSelected, setAcceptSkuVariantsSelected] = useState([])
    const [exceptSkuVariantsSelected, setExceptSkuVariantsSelected] = useState([])

    function onChangePriority(value) {
        setValidate({})
        setPriority(value)
    }

    function handleSetFieldAdding(name, value) {
        setValidate({})
        setFieldAdding({...fieldAdding, [name]: value})
    }

    function onChangeShippingLevel(value) {
        setValidate({})
        setShippingLevel(value)
    }

    function onChangeOriginalCarrier(value) {
        setValidate({})
        setOriginalCarrier(value)
    }

    function onChangeShippingCarrier(value) {
        setValidate({})
        setShippingCarrier(value)
    }

    function onChangeActive(value) {
        setActive(value)
    }

    function onChangePlatform(value) {
        setPlatform({allow: value})
    }

    function onChangeCountry(name, value) {
        setValidate({})
        setCountry({...country, [name]: value})
    }

    function onChangeState(name, value) {
        setValidate({})
        setState({...state, [name]: value})
    }

    function onChangeStore(name, value) {
        setValidate({})
        setStore({...store, [name]: value})
    }

    function onChangeType(name, value) {
        // if(detectByVariants && value.length > 10){
        //     message.error('Nhập tối đa 10 sku.')
        // }else{
            setValidate({})
            if(name === 'allow'){
                if(value.length > 0){
                    let acceptSkuVariantsSelectedNew = [...acceptSkuVariantsSelected]
                    acceptSkuVariantsSelectedNew = acceptSkuVariantsSelectedNew.filter(item => value.includes(item.sku))

                    setAcceptSkuVariantsSelected(acceptSkuVariantsSelectedNew)
                }else{
                    setAcceptSkuVariants([])
                    setAcceptSkuVariantsSelected([])
                }
            }else if(name === 'disallow'){
                if(value.length > 0){
                    let exceptSkuVariantsSelectedNew = [...exceptSkuVariantsSelected]
                    exceptSkuVariantsSelectedNew = exceptSkuVariantsSelectedNew.filter(item => value.includes(item.sku))

                    setExceptSkuVariantsSelected(exceptSkuVariantsSelectedNew)
                }else{
                    setExceptSkuVariants([])
                    setExceptSkuVariantsSelected([])
                }
            }
            setType({...type, [name]: value})
        // }
    }

    function onChangeTag(name, value) {
        setValidate({})
        setTag({...tag, [name]: value})
    }

    function onChangeTags(value) {
        setValidate([])
        setTags(value)
    }

    function onChangeWeight(type, value) {
        // setWeight({[type]: value})

        if (type === 'default' || type === '') {
            setWeight('')
        }else if(type === 'range'){
            const {from, to} = value
            setWeight({gte: from, lte: to})
        }else{
            setWeight({[type]: value})
        }
    }

    function onChangeDetectByVariant(value) {
        setDetectByVariants(value)
    }

    function _validate() {
        if (priority === '') {
            setValidate({...validate, priority: 'Priority is require.'})

            return true
        } else if (!Number.isInteger(parseInt(priority))) {
            setValidate({...validate, priority: 'Invalid priority.'})

            return true
        }

        if (original_carrier === '') {
            setValidate({...validate, original_carrier: 'Original carrier is require.'})

            return true
        }

        if (shipping_carrier === '') {
            setValidate({...validate, shipping_carrier: 'Shipping carrier is require.'})

            return true
        }

        if ((!!weight && weight.hasOwnProperty('lte') && isNaN(parseInt(weight.lte))) || (!!weight && weight.hasOwnProperty('gte') && isNaN(parseInt(weight.gte)))) {
            setValidate({...validate, weight: 'Weight is require.'})

            return true
        }

        if (parseFloat(weight.lte) < parseFloat(weight.gte)) {
            setValidate({...validate, weight: 'Weight range is wrong. Value lte must greater than gte.'})

            return true
        }

        if(fieldAdding.allow.includes('Country')){
            setValidate({...validate, countryAllow: 'Chưa hoàn thành nhập country.'})

            return true
        }

        if(fieldAdding.disallow.includes('Country')){
            setValidate({...validate, countryDisallow: 'Chưa hoàn thành nhập country.'})

            return true
        }

        if(fieldAdding.allow.includes('State')){
            setValidate({...validate, stateAllow: 'Chưa hoàn thành nhập state.'})

            return true
        }

        if(fieldAdding.disallow.includes('State')){
            setValidate({...validate, stateDisallow: 'Chưa hoàn thành nhập state.'})
            
            return true
        }

        if(fieldAdding.allow.includes('Store')){
            setValidate({...validate, storeAllow: 'Chưa hoàn thành nhập store.'})

            return true
        }

        if(fieldAdding.disallow.includes('Store')){
            setValidate({...validate, storeDisallow: 'Chưa hoàn thành nhập store.'})
            
            return true
        }

        if(fieldAdding.allow.includes('Sku')){
            setValidate({...validate, skuAllow: 'Chưa hoàn thành nhập sku.'})

            return true
        }

        if(fieldAdding.disallow.includes('Sku')){
            setValidate({...validate, skuDisallow: 'Chưa hoàn thành nhập sku.'})
            
            return true
        }

        if(fieldAdding.allow.includes('Tag')){
            setValidate({...validate, tagAllow: 'Chưa hoàn thành nhập tag.'})

            return true
        }

        if(fieldAdding.disallow.includes('Tag')){
            setValidate({...validate, tagDisallow: 'Chưa hoàn thành nhập tag.'})
            
            return true
        }

        // if(tags.length <= 0){
        //     setValidate({...validate, tags: 'Action add tag is require.'})
        //
        //     return true
        // }

        // if (shipping_level === '') {
        //     setValidate({...validate, shipping_level: 'Shipping Level is require.'})
        //
        //     return true
        // } else if (!Number.isInteger(parseInt(shipping_level))) {
        //     setValidate({...validate, shipping_level: 'Invalid priority.'})
        //
        //     return true
        // }

        return false
    }

    function updateShippingRule() {
        const {onUpdateShippingRule} = props

        let actions = {}
        if(shipping_level){
            actions = {
                tags,
                shipping_level
            }
        }else{
            actions = {
                tags
            }
        }

        const payload = {
            priority,
            platform,
            country,
            store,
            state,
            type,
            tag,
            weight: weight === '' ? {} : weight,
            shipping_carrier,
            active,
            original_carrier,
            actions: actions,
            detect_by_variants: detectByVariants
        }

        if(detectByVariants === true){
            if(type.allow.length > 0){
                const variants = {
                    allow: acceptSkuVariantsSelected
                }
    
                payload.variants = variants
            }else if(type.disallow.length > 0){
                const variants = {
                    disallow: exceptSkuVariantsSelected
                }
    
                payload.variants = variants
            }
        }

        if (_validate()) {
            return
        }

        if (typeof onUpdateShippingRule === 'function') {
            onUpdateShippingRule(payload)
        }
    }

    function onCancel() {
        const history = getHistory()
        history.push(`/shipping-rule`)
    }

    function onCloseModal() {
        setIsOpen(false)
    }

    function cancelShippingRule() {
        if (priority !== '' ||
            original_carrier !== '' ||
            shipping_carrier !== '' ||
            country.allow.length > 0 ||
            country.disallow.length > 0 ||
            store.allow.length > 0 ||
            store.disallow.length > 0 ||
            state.allow.length > 0 ||
            state.disallow.length > 0 ||
            type.allow.length > 0 ||
            type.disallow.length > 0 ||
            tags.length > 0) {
            setIsOpen(true)
        } else {
            const history = getHistory()
            history.push(`/shipping-rule`)
        }
    }

    async function getListAcceptSkuVariants() {
        try {
            const payload = {
                "sku" : type.allow ? type.allow : []
            }

            const {data: response} = await getSkuVariants(payload)
            
            const {success, message: error, data} = response

            if (!success) {
                // setLoading(false)
                return message.error(error)
            }

            const acceptSkuVariantsArr = []
            let i = 1
            for (const [key, value] of Object.entries(data)) {
                const skuVariantsItem = {
                    sku: key,
                    value,
                    'active': i === 1 ? true : false
                }

                acceptSkuVariantsArr.push(skuVariantsItem)
                i++
            }
            // setLoading(false)
            setAcceptSkuVariants(acceptSkuVariantsArr)
        } catch (e) {
            // setLoading(false)

            message.error(e.message)
        }
    }

    async function getListExceptSkuVariants() {

        try {
            const payload = {
                "sku" : type.disallow ? type.disallow : []
            }

            const {data: response} = await getSkuVariants(payload)
            
            const {success, message: error, data} = response

            if (!success) {
                // setLoading(false)
                return message.error(error)
            }

            const exceptSkuVariantsArr = []
            let i = 1
            for (const [key, value] of Object.entries(data)) {
                const skuVariantsItem = {
                    sku: key,
                    value,
                    'active': i === 1 ? true : false
                }

                exceptSkuVariantsArr.push(skuVariantsItem)
                i++
            }

            // setLoading(false)
            setExceptSkuVariants(exceptSkuVariantsArr)
        } catch (e) {
            // setLoading(false)

            message.error(e.message)
        }
    }

    function onActiveRowSku(type, index){
        if(type === 'accept'){
            let acceptSkuVariantsNew = [...acceptSkuVariants];
            acceptSkuVariantsNew[index]['active'] = true;

            setAcceptSkuVariants(acceptSkuVariantsNew)
        }else if(type === 'except'){
            let exceptSkuVariantsNew = [...exceptSkuVariants];
            exceptSkuVariantsNew[index]['active'] = true;

            setExceptSkuVariants(exceptSkuVariantsNew)
        }
    }

    function onDeActiveRowSku(type, index){
        if(type === 'accept'){
            let acceptSkuVariantsNew = [...acceptSkuVariants];
            acceptSkuVariantsNew[index]['active'] = false;

            setAcceptSkuVariants(acceptSkuVariantsNew)
        }else if(type === 'except'){
            let exceptSkuVariantsNew = [...exceptSkuVariants];
            exceptSkuVariantsNew[index]['active'] = false;

            setExceptSkuVariants(exceptSkuVariantsNew)
        }
    }

    function onChangeSkuVariantsSelected(type, sku, variant, value) {
        if(type === 'accept'){
            const checkSkuExist = acceptSkuVariantsSelected.filter(item => item.sku === sku)
            if(checkSkuExist.length > 0){
                const acceptSkuVariantsSelectedNew = [...acceptSkuVariantsSelected].map(item => {
                    if(item.sku === sku){
                        let variantsSelected = [...item.variants]
                        if(value === false){
                            variantsSelected = variantsSelected.filter(item => item !== variant)
                        }else if(value === true){
                            variantsSelected.push(variant)
                        }
    
                        return {
                            sku: item.sku,
                            variants: variantsSelected
                        }
                    }else{
                        return item
                    }
                })
    
                setAcceptSkuVariantsSelected(acceptSkuVariantsSelectedNew)
            }else{
                const acceptSkuVariantsSelectedNew = [...acceptSkuVariantsSelected]
                const skuVariantsSelectedItem = {
                    sku,
                    variants:[variant]
                }
                
                acceptSkuVariantsSelectedNew.push(skuVariantsSelectedItem)

                setAcceptSkuVariantsSelected(acceptSkuVariantsSelectedNew)
            }
            
        }else if(type === 'except'){
            const checkSkuExist = exceptSkuVariantsSelected.filter(item => item.sku === sku)
            if(checkSkuExist.length > 0){
                const exceptSkuVariantsSelectedNew = [...exceptSkuVariantsSelected].map(item => {
                    if(item.sku === sku){
                        let variantsSelected = [...item.variants]
                        if(value === false){
                            variantsSelected = variantsSelected.filter(item => item !== variant)
                        }else if(value === true){
                            variantsSelected.push(variant)
                        }
    
                        return {
                            sku: item.sku,
                            variants: variantsSelected
                        }
                    }else{
                        return item
                    }
                })
    
                setExceptSkuVariantsSelected(exceptSkuVariantsSelectedNew)
            }else{
                const exceptSkuVariantsSelectedNew = [...exceptSkuVariantsSelected]
                const skuVariantsSelectedItem = {
                    sku,
                    variants:[variant]
                }
                
                exceptSkuVariantsSelectedNew.push(skuVariantsSelectedItem)

                setExceptSkuVariantsSelected(exceptSkuVariantsSelectedNew)
            }
        }
    }

    const {error} = props

    useEffect(() => {
        if (Object.keys(props.shippingRules).length > 0) {
            const {
                priority,
                platform,
                country,
                state,
                store,
                type,
                tag,
                original_carrier,
                weight,
                shipping_carrier,
                deleted_at,
                actions,
                detect_by_variants,
                variants
            } = props.shippingRules

            setPlatform(platform)
            setPriority(priority)
            setCountry(country)
            setState(state)
            setStore(store)
            setType(type)
            setTag(tag)
            setShippingCarrier(shipping_carrier)
            setWeight(weight || '')
            setOriginalCarrier(original_carrier)
            setDetectByVariants(detect_by_variants)

            setAcceptSkuVariantsSelected(variants && variants.allow ? variants.allow : [])
            setExceptSkuVariantsSelected(variants && variants.disallow ? variants.disallow : [])

            if(actions){
                setTags(actions.tags || '')
                setShippingLevel(actions.shipping_level || '')
            }

            if (deleted_at) {
                setActive(false)
            } else {
                setActive(true)
            }
        }
        // eslint-disable-next-line
    }, [props.shippingRules])

    useEffect(() => {
        if(type.allow.length > 0){
            getListAcceptSkuVariants()
        }
    }, [type.allow])

    useEffect(() => {
        if(type.disallow.length > 0){
            getListExceptSkuVariants()
        }
    }, [type.disallow])


    return (
        <div className="FormShippingRule">
            <SingleInput
                placeholder='Input priority'
                label='Priority'
                name='priority'
                type='number'
                value={priority}
                validate={validate.priority}
                onChange={onChangePriority}
            />

            <SelectMulti label='Platform' platforms={props.platforms} value={platform.allow}
                         onChange={onChangePlatform}/>

            <MultiInput
                label='Country'
                value_first={country.allow}
                value_last={country.disallow}
                onChange={onChangeCountry}
                fieldAddingFirst={fieldAdding.allow}
                fieldAddingLast={fieldAdding.disallow}
                handleSetFieldAdding={handleSetFieldAdding}
                validateFirst={validate.countryAllow}
                validateLast={validate.countryDisallow}
            />

            <MultiInput
                label='State'
                value_first={state.allow}
                value_last={state.disallow}
                onChange={onChangeState}
                fieldAddingFirst={fieldAdding.allow}
                fieldAddingLast={fieldAdding.disallow}
                handleSetFieldAdding={handleSetFieldAdding}
                validateFirst={validate.stateAllow}
                validateLast={validate.stateDisallow}
            />

            <MultiInput
                label='Store'
                value_first={store.allow}
                value_last={store.disallow}
                onChange={onChangeStore}
                fieldAddingFirst={fieldAdding.allow}
                fieldAddingLast={fieldAdding.disallow}
                handleSetFieldAdding={handleSetFieldAdding}
                validateFirst={validate.storeAllow}
                validateLast={validate.storeDisallow}
            />

            <MultiInputSKU
                label='Sku'
                value_first={type.allow}
                value_last={type.disallow}
                onChange={onChangeType}
                fieldAddingFirst={fieldAdding.allow}
                fieldAddingLast={fieldAdding.disallow}
                handleSetFieldAdding={handleSetFieldAdding}
                validateFirst={validate.skuAllow}
                validateLast={validate.skuDisallow}
                detectByVariants={detectByVariants}
                onChangeDetectByVariant={onChangeDetectByVariant}
                acceptSkuVariants={acceptSkuVariants}
                exceptSkuVariants={exceptSkuVariants}
                onActiveRowSku={onActiveRowSku}
                onDeActiveRowSku={onDeActiveRowSku}
                acceptSkuVariantsSelected={acceptSkuVariantsSelected}
                exceptSkuVariantsSelected={exceptSkuVariantsSelected}
                onChangeSkuVariantsSelected={onChangeSkuVariantsSelected}
            />
            <MultiInput
                label='Tag'
                value_first={!!tag && !!tag.allow ? tag.allow : []}
                value_last={!!tag && !!tag.disallow ? tag.disallow : []}
                onChange={onChangeTag}
                fieldAddingFirst={fieldAdding.allow}
                fieldAddingLast={fieldAdding.disallow}
                handleSetFieldAdding={handleSetFieldAdding}
                validateFirst={validate.tagAllow}
                validateLast={validate.tagDisallow}
                regex={/,\n|,/}
            />

            {
                weight !== undefined &&
                <RadioMultiInput label='Weight' validate={validate.weight} value={weight} onChange={onChangeWeight}/>
            }

            <SelectInput label='Shipping carrier' value={shipping_carrier} onChange={onChangeShippingCarrier}/>

            <SingleInput
                placeholder='Input original carrier'
                label='Original carrier'
                name='original_carrier'
                type='text'
                value={original_carrier}
                validate={validate.original_carrier}
                onChange={onChangeOriginalCarrier}
            />

            <AddTagInput
                label='Action'
                value_first={tags}
                onChange={onChangeTags}
                validate={validate.tags}
                shipping_level={shipping_level}
                onChangeShippingLevel={onChangeShippingLevel}
                validateShippingLevel={validate.shipping_level}
            />

            <RadioInput label='Status' value={active} onChange={onChangeActive}/>

            <div className="Actions">
                <div className="d-flex align-items-center justify-content-end">
                    {
                        !!error && error.length > 0 && <div className="text-danger mr-3">{error}</div>
                    }
                    <div>
                        <Button type='default' className='mr-2' onClick={cancelShippingRule}>Cancel</Button>
                        <Button type='primary' loading={props.loading} onClick={updateShippingRule}>Save</Button>
                    </div>
                </div>
            </div>

            <ModalConfirm isModalVisible={isOpen} onOk={onCancel} onCancel={onCloseModal}/>
        </div>
    )
}

export default FormShippingRule